/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Current user permissions for database entries
 * @export
 * @interface ActivePermission
 */
export interface ActivePermission {
    /**
     * 
     * @type {boolean}
     * @memberof ActivePermission
     */
    create?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivePermission
     */
    readOwnedEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivePermission
     */
    readForeignEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivePermission
     */
    readAllEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivePermission
     */
    updateOwnedEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivePermission
     */
    updateForeignEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivePermission
     */
    deleteOwnedEntries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActivePermission
     */
    deleteForeignEntries?: boolean;
}

/**
 * Check if a given object implements the ActivePermission interface.
 */
export function instanceOfActivePermission(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ActivePermissionFromJSON(json: any): ActivePermission {
    return ActivePermissionFromJSONTyped(json, false);
}

export function ActivePermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivePermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'create': !exists(json, 'create') ? undefined : json['create'],
        'readOwnedEntries': !exists(json, 'readOwnedEntries') ? undefined : json['readOwnedEntries'],
        'readForeignEntries': !exists(json, 'readForeignEntries') ? undefined : json['readForeignEntries'],
        'readAllEntries': !exists(json, 'readAllEntries') ? undefined : json['readAllEntries'],
        'updateOwnedEntries': !exists(json, 'updateOwnedEntries') ? undefined : json['updateOwnedEntries'],
        'updateForeignEntries': !exists(json, 'updateForeignEntries') ? undefined : json['updateForeignEntries'],
        'deleteOwnedEntries': !exists(json, 'deleteOwnedEntries') ? undefined : json['deleteOwnedEntries'],
        'deleteForeignEntries': !exists(json, 'deleteForeignEntries') ? undefined : json['deleteForeignEntries'],
    };
}

export function ActivePermissionToJSON(value?: ActivePermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'create': value.create,
        'readOwnedEntries': value.readOwnedEntries,
        'readForeignEntries': value.readForeignEntries,
        'readAllEntries': value.readAllEntries,
        'updateOwnedEntries': value.updateOwnedEntries,
        'updateForeignEntries': value.updateForeignEntries,
        'deleteOwnedEntries': value.deleteOwnedEntries,
        'deleteForeignEntries': value.deleteForeignEntries,
    };
}

